import { render } from "./NavigationPage.vue?vue&type=template&id=36263dcc&scoped=true"
import script from "./NavigationPage.vue?vue&type=script&lang=js"
export * from "./NavigationPage.vue?vue&type=script&lang=js"

import "./NavigationPage.vue?vue&type=style&index=0&id=36263dcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36263dcc"]])

export default __exports__